import { render, staticRenderFns } from "./SectionLanding.vue?vue&type=template&id=798bcece&scoped=true&"
import script from "./SectionLanding.vue?vue&type=script&lang=js&"
export * from "./SectionLanding.vue?vue&type=script&lang=js&"
import style0 from "./SectionLanding.vue?vue&type=style&index=0&id=798bcece&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798bcece",
  null
  
)

export default component.exports